import address from '../../../assets/images/about/contract/address.png'
import phone from '../../../assets/images/about/contract/phone.png'
import cooperation from '../../../assets/images/about/contract/cooperation.png'

import code from '../../../assets/images/about/contract/code.png'

import styles from './style.module.scss'
import { Image } from 'antd'

const contractList = [
    {
        index: 1,
        icon: address,
        name: '总部地址（南京）',
        tip: '南京市建邺区云龙山路88号烽火科技大厦'
    },
    {
        index: 2,
        icon: phone,
        name: '电话',
        tip: '400-110-0111'
    },
    {
        index: 3,
        icon: cooperation,
        name: '渠道合作',
        tip: '025-66777050'
    }
];

const Contract = () => {
    return (
        <div className={styles['contract-wrapper']}>
            <div className={styles['information-wrapper']}>
                <p className={styles['title']}>联系方式</p>
                {contractList.map((item) => (
                    <div className={styles['information-item']} key={item.index}>
                        <img src={item.icon} alt="" />
                        <div className={styles['information-content']}>
                            <p className={styles['name']}>{item.name}</p>
                            <p className={styles['tip']}>{item.tip}</p>
                        </div>
                    </div>
                ))}
            </div>
            <div className={styles['focus-wrapper']} >
                <p className={styles['title']}>关注我们</p>
                <Image src={code} preview={false}width={140} height={140} />
                <p>烽火星空微信公众号</p>
            </div>
        </div>
    )
}

export default Contract